import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  useState,
  useSubscription,
} from '@rivethealth/client/common/core/hooks';
import { HookDirective } from '../core/hook';

@Component({
  selector: 'update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.scss'],
})
export class UpdateModalComponent extends HookDirective {
  constructor(
    readonly router: Router,
    changeDetector: ChangeDetectorRef,
  ) {
    super(changeDetector);
  }

  noScroll = false;
  title: string;
  outerWidth: string;
  width: string;
  allowOverflow: boolean = false;

  get _() {
    const [visible, setVisible] = useState(false);

    useSubscription(
      this.router.events,
      {
        next: event => {
          if (event instanceof NavigationEnd) {
            setVisible(true);
          }
        },
      },
      [],
    );

    const close = () => {
      setVisible(false);
    };

    const reload = () => {
      setVisible(false);
      location.reload();
    };

    return { visible, setVisible, close, reload };
  }
}
